[[INPUT-DECIMAL]]
